// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tox-fullscreen .tox.tox-tinymce.tox-fullscreen{z-index:1040!important}", "",{"version":3,"sources":["webpack://./resources/js/Components/input-wysiwyg.vue"],"names":[],"mappings":"AACA,gDACE,sBAAF","sourcesContent":["\n.tox-fullscreen .tox.tox-tinymce.tox-fullscreen {\n  z-index: 1040 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
